var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImportant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    className: "st0",
    d: "M19,6.6c0.1,1.1,0.2,2.2,0.4,3.3c0.2,1.1,0.5,2.1,0.9,3.1c0.4,1,0.9,1.9,1.5,2.8 c0.6,0.9,1.4,1.7,2.3,2.3c0,0.6-0.3,1.2-0.8,1.6c-0.5,0.4-1,0.6-1.6,0.6h-6.4c-0.2,0.7-0.5,1.4-1.1,1.8c-0.6,0.5-1.3,0.7-2.1,0.7 c-0.8,0-1.5-0.3-2.1-0.7c-0.6-0.5-1-1.1-1.2-1.8H2.4c-0.6,0-1.2-0.2-1.6-0.6c-0.5-0.4-0.7-1-0.8-1.6c0.9-0.7,1.7-1.5,2.3-2.4 C3,14.9,3.5,13.9,3.8,13c0.4-1,0.7-2,0.8-3.1C4.8,8.8,5,7.7,5,6.6c0.1-0.8,0.3-1.5,0.8-2.2c0.5-0.7,1-1.3,1.7-1.8 c0.7-0.5,1.4-0.9,2.2-1.2c1.4-0.6,3.1-0.6,4.5,0c0.8,0.3,1.6,0.7,2.3,1.2c0.7,0.5,1.3,1.1,1.8,1.8C18.7,5,19,5.8,19,6.6z M20.8,18.1 c-0.7-0.8-1.3-1.6-1.8-2.5c-0.5-0.9-0.8-1.8-1.1-2.8c-0.3-1-0.5-1.9-0.7-2.9c-0.2-1-0.3-2-0.4-3c0-0.5-0.2-1-0.6-1.4 C15.9,5,15.5,4.6,15,4.2c-0.5-0.3-1-0.6-1.5-0.8c-0.5-0.2-1-0.3-1.5-0.3c-0.5,0-1,0.1-1.5,0.3C10,3.7,9.5,3.9,9,4.2 C8.5,4.6,8.1,4.9,7.7,5.4C7.4,5.8,7.2,6.2,7.2,6.7c-0.1,1-0.2,2-0.3,3c-0.2,1-0.4,2-0.7,3c-0.3,1-0.7,1.9-1.2,2.8 c-0.5,0.9-1.1,1.7-1.8,2.5L20.8,18.1z M12,21.8c0.2,0,0.2-0.1,0.2-0.3s-0.1-0.3-0.2-0.3c-0.5,0-0.9-0.2-1.2-0.5 c-0.3-0.3-0.5-0.8-0.5-1.2c0-0.2-0.1-0.3-0.3-0.3c-0.1,0-0.3,0.1-0.3,0.2c0,0,0,0,0,0.1C9.7,20.8,10.7,21.8,12,21.8 C12,21.8,12,21.8,12,21.8L12,21.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportant);
export default __webpack_public_path__ + "static/media/important.2b4bd5506b3b10a326ee9b7a08e1dc67.svg";
export { ForwardRef as ReactComponent };